<template>
  <div :class="['v-table-header-sortable-arrows-ui', stateClass]">
    <i class="fr fr-chevron-up" />
    <i class="fr fr-chevron-down" />
  </div>
</template>

<script lang="ts" setup>
  // Types
  import { ESortingDirection } from '~/misc/resource/types';

  const props = defineProps({
    direction: {
      type: String as PropType<ESortingDirection | null>,
      default: null,
    },
  });

  const stateClass: ComputedRef<string> = computed<string>(() => {
    const stateMap: Record<ESortingDirection, string> = {
      [ESortingDirection.ASC]: 'v-table-header-sortable-arrows-ui--asc',
      [ESortingDirection.DESC]: 'v-table-header-sortable-arrows-ui--desc',
    };

    return props.direction ? stateMap[props.direction] : '';
  });
</script>
